import React from "react";

export const Loader = () => (
  <div className="loader text-info">
    <div className="loader-backdrop">
      <span className="glyphicon glyphicon-refresh spin-right" />
    </div>
  </div>
);
